export default function validate(value, rules) {
    let result = {
        valid: true,
        error: '',
    };
    if (!rules) {
        return result;
    }

    if (result.valid && rules.required) {
        result = validateRequired(value, rules.errorMessage && rules.errorMessage.required);
    }
    if (result.valid && rules.alphaOnly) {
        result = validateAlphaOnly(value, rules.errorMessage && rules.errorMessage.alphaOnly);
    }
    if (result.valid && rules.email) {
        result = validateEmail(value, rules.errorMessage && rules.errorMessage.email);
    }
    if (result.valid && rules.maxlength) {
        result = validateMaxlength(value, rules.maxlength, rules.errorMessage && rules.errorMessage.maxlength);
    }
    if (result.valid && rules.minlength) {
        result = validateMinlength(value, rules.minlength, rules.errorMessage && rules.errorMessage.minlength);
    }
    if (result.valid && rules.regex) {
        result = validateRegex(value, rules.regex, rules.errorMessage && rules.errorMessage.regex);
    }
    if (result.valid && rules.validateLuhn) {
        result = validateLuhn(value, rules.errorMessage && rules.errorMessage.luhn);
    }
    if (result.valid && rules.list) {
        result = validateList(value, rules.errorMessage && rules.errorMessage.list, rules.list);
    }

    return result;
}

const validateRequired = (value, err) => {
    if (!value || !value.toString().trim().length) {
        return {
            valid: false,
            error: err,
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateList = (value, err, list) => {
    if (!value || !list || !Array.isArray(list) || !list.includes(value)) {
        return {
            valid: false,
            error: err,
        };
    }
    return {
        valid: true,
        error: '',
    };
};

const validateAlphaOnly = (value, err) => {
    if (value && !/^[^\d]+$/i.test(value)) {
        return {
            valid: false,
            error: err,
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateEmail = (value, err) => {
    const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (value && !re.test(value)) {
        return {
            valid: false,
            error: err,
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateMaxlength = (value, maxlength, err) => {
    if (value && value.toString().trim().length > maxlength) {
        return {
            valid: false,
            error: err,
            textParams: {
                maxlength: maxlength,
            },
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateMinlength = (value, minlength, err) => {
    if (value && value.toString().trim().length < minlength) {
        return {
            valid: false,
            error: err,
            textParams: {
                minlength: minlength,
            },
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateRegex = (value, regex, err) => {
    // Validate zipcode by using the regex provided in settings
    const validationRegex = new RegExp(regex);
    if (value && !validationRegex.test(value)) {
        return {
            valid: false,
            error: err,
        };
    }

    return {
        valid: true,
        error: '',
    };
};

const validateLuhn = (value, err) => {
    let nCheck = 0;
    let nDigit = 0;
    let bEven = false;
    const val = value.replace(/\s/g, '');

    for (let n = val.length - 1; n >= 0; n--) {
        const cDigit = val.charAt(n);
        nDigit = parseInt(cDigit, 10);

        if (bEven) {
            nDigit *= 2;
            if (nDigit > 9) {
                nDigit -= 9;
            }
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    if (nCheck % 10 !== 0) {
        return {
            valid: false,
            error: err,
        };
    }

    return {
        valid: true,
        error: '',
    };
};
